import { render, staticRenderFns } from "./ProductEditor.vue?vue&type=template&id=0a972078"
import script from "./ProductEditor.vue?vue&type=script&lang=js"
export * from "./ProductEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductEditor.vue?vue&type=style&index=0&id=0a972078&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports